import type { IEmpresaComStatus } from './derivarProcessos';

/**
 * TOP ERROS DA ETAPA (13/10, pedido do dono: "me crie um top erros quando eu
 * clicar na etapa para entender quais são os maiores erros").
 *
 * Agrupa as empresas em erro pela MENSAGEM. Mensagens que só diferem em números
 * (código da empresa, competência, valor, protocolo) são o mesmo erro — sem a
 * normalização cada empresa viraria um grupo de 1 e o ranking não diria nada.
 */
export interface GrupoDeErro {
  /** Chave normalizada — o que identifica o grupo. */
  chave: string;
  /** A mensagem como veio (a primeira do grupo), para exibir. */
  texto: string;
  quantidade: number;
  codis: string[];
}

export const SEM_MENSAGEM = '(sem mensagem registrada)';

/** A mensagem que explica o erro da linha: a do erro vence a do alerta. */
export const mensagemDoErro = (item: IEmpresaComStatus): string | null =>
  item.motivoErro || item.motivo || item.motivoEmOutroBot || item.motivoAviso || null;

export const chaveDoErro = (mensagem: string | null): string =>
  (mensagem ?? SEM_MENSAGEM)
    .toLowerCase()
    .replace(/\d+([.,/:-]\d+)*/g, '#')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 140);

export const topErros = (itens: IEmpresaComStatus[], limite = 8): GrupoDeErro[] => {
  const grupos = new Map<string, GrupoDeErro>();
  itens.forEach(item => {
    const mensagem = mensagemDoErro(item);
    const chave = chaveDoErro(mensagem);
    const grupo = grupos.get(chave);
    if (grupo) {
      grupo.quantidade += 1;
      grupo.codis.push(item.codiEmp);
    } else {
      grupos.set(chave, {
        chave,
        texto: (mensagem ?? SEM_MENSAGEM).trim(),
        quantidade: 1,
        codis: [item.codiEmp],
      });
    }
  });
  return Array.from(grupos.values())
    .sort((a, b) => b.quantidade - a.quantidade || a.texto.localeCompare(b.texto, 'pt-BR'))
    .slice(0, limite);
};
